import type { BadgeColor } from "@volca/ui/components/ui/badge";
import type { ProfitabilityReport } from "./types";

export const templateStatus = (
  report: ProfitabilityReport,
): { label: string; color: BadgeColor } => {
  if (report.build_status === "building")
    return { label: "Building", color: "information" };
  if (report.build_status === "failed")
    return { label: "Build failed", color: "danger" };
  if (report.build_status === "needs_input")
    return { label: "Needs answers", color: "warning" };
  // Not "Review": that is the template page's tab. Built and not yet
  // published is one step from running; published with a draft is changes
  // to look at before they apply.
  if (report.draft_pending)
    return report.published
      ? { label: "Changes to review", color: "warning" }
      : { label: "Ready to publish", color: "information" };
  if (report.published) return { label: "Ready", color: "success" };
  // One name for an agent not yet published, however it was started.
  return { label: "Setting up", color: "information" };
};
